<template>
  <div class="c-paginate">
    <c-select
      class="per-page"
      placeholder=""
      form-label="Itens por página"
      data-cy="items-per-page"
      :value="per_page"
      :options="perPageOptions"
      :allow-empty="false"
      :searchable="false"
      @input="changePerPage"
    />

    <div class="controls">
      <c-button
        icon="first"
        alternative
        class="button"
        :disabled="disablePrevButton || isFetching"
        @click="updatePaginate('first-page')"
      />
      <c-button
        icon="previous"
        alternative
        class="button"
        :disabled="disablePrevButton || isFetching"
        @click="updatePaginate('previous-page')"
      />

      <p class="info">
        {{ info }}
      </p>

      <c-button
        icon="next"
        alternative
        class="button"
        :disabled="disableNextButton || isFetching"
        @click="updatePaginate('next-page')"
      />
      <c-button
        icon="last"
        alternative
        class="button"
        :disabled="disableNextButton || isFetching"
        @click="updatePaginate('last-page')"
      />
    </div>
  </div>
</template>

<script>
import CSelect from './CSelect'
import CButton from './CButton'
import reconstruct from 'reconstruct'

const DEFAULT_PAGINATE = {
  total: 0,
  per_page: 10,
  current_page: 1,
  last_page: 1,
  from: 0,
  to: 0
}

const properties = reconstruct(
  DEFAULT_PAGINATE,
  (placeholder, property) => ({
    [property]: function () {
      const value = this.paginate[property]
      const isPositive = !!(typeof value === 'number' && value >= 0)
      return isPositive ? value : placeholder
    }
  })
)

export default {
  components: { CSelect, CButton },
  props: {
    isFetching: Boolean,
    perPageOptions: {
      type: Array,
      default: () => [ 5, 10, 25, 50 ]
    },
    paginate: {
      type: Object,
      default: () => ({ ...DEFAULT_PAGINATE })
    }
  },
  computed: {
    ...properties,
    pages () {
      const pages = Math.ceil(this.total / this.per_page) || 1
      return pages
    },
    disablePrevButton () {
      const isDisabled = this.current_page <= 1
      return isDisabled
    },
    disableNextButton () {
      const isDisabled = this.current_page >= this.pages
      return isDisabled
    },
    info () {
      const info = `${this.from} - ${this.to} de ${this.total}`
      return info
    }
  },
  methods: {
    changePerPage (limit) {
      this.$emit('update-paginate', {
        limit,
        page: DEFAULT_PAGINATE.current_page
      })
    },
    updatePaginate (action) {
      const actions = {
        'first-page': 1,
        'previous-page': this.disablePrevButton ? 1 : this.current_page - 1,
        'next-page': this.disableNextButton ? this.pages : this.current_page + 1,
        'last-page': this.pages
      }
      this.$emit('update-paginate', {
        limit: this.per_page,
        page: actions[action] || DEFAULT_PAGINATE.current_page
      })
    }
  }
}
</script>

<style lang=scss>
@import '~@styles/convenia-components/reference.scss';

$c-paginate-control-background: #fff;

.c-paginate {
  display: flex;
  align-items: center;

  & > .per-page {
    width: 120px;

    & > .label { margin-left: inner-base(.5); }

    .multiselect__option::after { content: none !important; }

    .multiselect__tags,
    .multiselect--active .multiselect__tags {
      padding: 0;
      border: 1px solid rgb(234, 237, 239);
      border-radius: inner-base();
      background-color: $c-paginate-control-background;
    }

    .multiselect__single {
      margin: 0;
      padding: 0 0 0 inner-base(1);
      height: 43px;
      line-height: 43px;
      background-color: transparent;
    }
  }

  & > .controls {
    @extend %c-paginate-controls;
    margin-left: auto;
  }
}

%c-paginate-controls {
  display: flex;
  align-items: center;

  & > * + * { margin-left: inner-base(.5); }

  & > .button {
    background-color: $c-paginate-control-background;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CPaginate.vue